import React, { useState } from "react";
import { HTMLDescription } from './HTMLDescription';


const ProjectCard = ({ data }) => {
  // const { title, name, project_photo_detail, description, live_url } = data;
  const [open, setOpen] = useState(false);

  const handleModalOpen = () => setOpen(true);
  const handleModalClose = () => setOpen(false);

  return (
    <div className="col-md-4 col-sm-6 col-xs-12">
      <div className="card project-card">
        <img
          src={data.project_photo_detail.length > 0 ?  data.project_photo_detail[0].image : "#"}
          className="card-img-top project-image"
          alt={data.name}
        />
        <div className="card-body">
          <h5 className="card-title">{data.title}</h5>
          <div className="d-flex justify-content-center gap-3 mt-3">
          <a
            href={data.live_url || "#"}
            className={`btn btn-sm filterBtn ${!data.live_url ? 'disabled' : ''}`}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
                if (!data.live_url) e.preventDefault(); // prevent navigation if no URL
            }}
            >
            Live Demo
            </a>
            <button className="btn btn-sm filterBtn" onClick={handleModalOpen}>
              Read More
            </button>
          </div>
        </div>
      </div>

      {/* Custom Modal */}
      {open && (

        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block" }}
          id="projectModal"
        >
          <div
            className="modal-dialog"
            style={{
              maxWidth: "600px", // medium width
            }}
          >
            <div className="modal-content" style={{ maxHeight: "90vh", overflow: "hidden" }}>
              <div className="modal-header">
                <h5 className="modal-title">{data.title}</h5>
                {/* Close Button (X) */}
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalClose}
                  aria-label="Close"
                ></button>
              </div>

              {/* Scrollable body */}
              <div
                className="modal-body"
                style={{
                  overflowY: "auto",
                  maxHeight: "60vh", // adjust as needed
                }}
              >

                <HTMLDescription description={data.description} />

                {/* Skills */}
                {
                  // data.project_technology_detail.length > 0 ?
                  data.skill ?
                  <>
                  <div className="mt-3 text-left">
                  <strong>Skills:</strong>{" "}
                  <span className="text-muted">
                    {
                      data.skill
                    // data.project_technology_detail.map(skill => (
                    //   skill.name + " | " 
                    //   ))
                    }

                  </span>
                  </div>
                  </>
                  :
                  ""

                }

                {/* Duration */}
                {(data.start || data.end) && (
                  <div className="mt-2 text-left">
                    <strong>Duration:</strong>{" "}
                    <span className="text-muted">{data.start} Year(s) {data.end} Month(s)</span>
                  </div>
                )}

                {/* Team Size */}
                { data.team_size > 1 &&
                  <div className="mt-2 text-left">
                    <strong>Team Size :</strong>{" "}
                    <span className="text-muted">{data.team_size}</span>
                  </div>
                }


              </div>

              <div className="modal-footer">
                <a
                  href={data.live_url || "#"}
                  className={`btn btn-sm filterBtn ${!data.live_url ? "disabled" : ""}`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => {
                    if (!data.live_url) e.preventDefault();
                  }}
                >
                  Live Demo
                </a>
                <button
                  type="button"
                  className="btn btn-sm filterBtn"
                  onClick={handleModalClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>


      )}
      
    </div>
  );
};

export default ProjectCard;
